import { cardListStyles } from "@insite/content-library/Widgets/SavedPayments/SavedPaymentsCardList";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { css } from "styled-components";

cardListStyles.sortByGridItem = {
    width: [12, 12, 7, 7, 7],
    css: css`
        > div[class^="FormFieldStyle"] {
            > div[class^="FormInputWrapper"] {
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        null,
                        null,
                        null,
                        css`
                            width: 150px;
                        `,
                        null,
                    ])}
            }
        }
    `,
};
